import React from 'react'

const RadioGroup = ({
	options,
	name,
	register,
	required,
	disabled,
	label,
	errors,
	defaultValue,
}) => {
	return (
		<div>
			{/* CSS directly in JSX */}
			<style>
				{`
          .radio-group-container {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .radio-option {
            display: flex;
            align-items: center;
          }

          .radio-option input {
            margin-right: 0.5rem;
          }

          @media (max-width: 600px) {
            .radio-group-container {
              flex-direction: column;
             justify-content: center;
            }
          }

          .radio-label {
            padding:0 !important;
            color: black;
            font-size: 14px;
          }

          .error-message {
            color: red;
            margin-top: 0.5rem;
          }
        `}
			</style>

			{label && <p className='radio-label'>{label}</p>}

			<div className='radio-group-container'>
				{options.map((option) => (
					<div className='radio-option' key={option.value}>
						<input
							type='radio'
							id={`${name}-${option.value}`}
							disabled={disabled}
							{...register(name, {
								required,
								value: option.value,
							})}
							value={option.value}
							defaultChecked={option.value === defaultValue}
						/>
						<label
							htmlFor={`${name}-${option.value}`}
							className='radio-label'
						>
							{option.label}
						</label>
					</div>
				))}
			</div>

			{errors[name] && (
				<div className='error-message'>
					{errors[name].message ||
						`Veuillez sélectionner une option pour ${label?.toLowerCase()}`}
				</div>
			)}
		</div>
	)
}

export default RadioGroup

